import Checkbox from './components/Checkbox'
import ControlLabel from './components/ControlLabel'
import Label from './components/Label'
import Radio from './components/Radio'

export default { Checkbox, ControlLabel, Label, Radio }
